<div ngClass="p-t-l p-r-l">
	<button mat-icon-button class="close-button" (click)="onCloseClick()">
		<img
			src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/crossBlack/public"
		/>
	</button>
</div>
<br />
<div ngClass="m-l-l">
	<h2 i18n="@@editCreatedBy_editSocialMediaAccounts_title">
		Edit Social Media Accounts
	</h2>
</div>
<mat-dialog-content>
	<app-fundraiser-contact
		[fundraiserData]="this.data"
		(shareForm)="receiveForm($event)"
		(shareFormValidity)="receiveFormValidity($event)"
	></app-fundraiser-contact>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button
		[disabled]="isFormValid"
		mat-flat-button
		color="accent"
		id="fundraiserContactSaveButton"
		(click)="dialogClose()"
	>
		<span i18n="@@button_save">Save</span>
		<mat-icon *ngIf="isLoading" ngClass="m-l-xs">
			<mat-spinner color="primary" diameter="16" i18n="@@editCreatedBy_spinner">
			</mat-spinner>
		</mat-icon>
	</button>
</mat-dialog-actions>
